import React, { useState, useEffect, useContext } from 'react';
import { useQuery, useApolloClient } from '@apollo/client';
import { getStatusListsQuery, getStatusListsCntQuery, getStatusActivityQuery } from "../../graphql/status_queries";
import { GlobalContext } from "../../hooks/globalContext";
import apiCall from '../../utility/api';


type dataProps = {
	data: any;
	func: any;
	searchVal: any
	pageNo: any
	setTotalPages: any
	setTotalRecords: any
	isRefresh?: any,
	setIsRefresh?: any
	setRefreshToast?: any
	activityData?: any
	activityFunc?: any
	selectedAct?: any
	isFilter?: any
	dropDownValue1?: any
	setIsFilter?: any
	dropDownValue2?: any
	filterArray?: any
	automationIds?: Array<any>
	setAutomationJsonData?: any
	final_Targetdata?: any
	set_final_Targetdata?: any
	searchTargetVal?: any
	deviceSearchVal?: any
	setDeviceSearchVal?: any
	isOverlayFilter?: any
	dropDownValue1Overlay?: any
	setIsOverlayFilter?: any
	dropDownValue2Overlay?: any
	overlayFilterArray?: any
	filterMenuOpenOverlay?: any
	overlayPageNo?: any
	setTotalOverlayPages?: any
	setTotalOverlayRecords?: any
	setExportDetails?: any
	exportBtnClicked?: any
	setExportBtnClicked?: any
	setOverlayExportBtnClicked?: any
	setOverlayExportDetails?: any
	overlayExportBtnClicked?: any
	jobType?: string
	setJsonDataPkg?: any
	setUiDataPkg?: any
	setJsonDataApp?: any
	setUiDataApp?: any
	setJsonDataAdv?: any
	setUiDataAdv?: any
	formDataPkg?: any
	formDataApp?: any
	formDataAdv?: any
	setFormDataPkg?: any
	setFormDataApp?: any
	setFormDataAdv?: any
	handleEditData?: any
	setStatus?: any
	status?: any
	IDX?: any
}


export const Status_func = (props: dataProps) => {
	const contextValue: any = useContext(GlobalContext);

	const tenantName = contextValue.tenantName;
	const selectedActivity = props.selectedAct;
	console.log("searchVal--------------------", props.searchVal);
	console.log("contextValue--------------------", contextValue);


	const getStatusList = async (whereCondition: any, limit: Number | null = null, offset: Number | null = null) => {
		try {
			const { data, status } = await apiCall(`/troubleshoot/getStatusList`, { ...whereCondition, limit, offset });

			if (data && status == 'success') {
				props.func(data);
			} else {
				props.func([]);
			}
		} catch (error) {
			console.log("fetchdartTemplateList error=", error);
			return { data: [], status: 'failed' };
		}

	};


	const getStatusListCnt = async (mainWhereCondition: object) => {

		try {
			const { data, status } = await apiCall(`/troubleshoot/getStatusListCount`, { ...mainWhereCondition });
			if (data && status == 'success') {
				//console.log("Status data-2*******************************",data); 
				props.setTotalRecords(data.totalRecords);
				props.setTotalPages(Math.ceil((data.totalPages)));
			}
		} catch (error) {
			props.setTotalRecords(0);
			props.setTotalPages(0);

		}
	}


	const exportStatusList = async (whereCondition: any) => {
		try {
			const { data, status } = await apiCall(`/troubleshoot/getStatusList`, { ...whereCondition });

			if (data && status == 'success') {
				props.setExportDetails(data);
			} else {
				props.setExportDetails([]);
			}
			props.setExportBtnClicked(false);
		} catch (error) {
			console.log("fetchdartTemplateList error=", error);
			return { data: [], status: 'failed' };
		}

	};

	const getStatusActivity = async (whereCondition: any) => {
		try {
			// Validate input
			if (!whereCondition) {
				console.error('No conditions provided for status activity');
				return;
			}

			// Perform API call with error handling
			const { data, status } = await apiCall('/troubleshoot/getStatusActivity', { ...whereCondition });

			// Check for successful response
			if (status !== 'success' || !data) {
				props.activityFunc([]);
				console.warn('Failed to retrieve status activity', { status, data });
				return;
			}

			// Update state with retrieved data
			if (props.activityFunc) {
				props.activityFunc(data);
			}

			// Conditional final target data update
			if (props.selectedAct) {
				props.set_final_Targetdata(data);
			}

		} catch (error) {
			// Comprehensive error handling
			console.error('Error in getStatusActivity:', error);
			// Optionally, you could add error notification to user
			// props.showErrorNotification('Failed to fetch status activity');
		}
	};
	const getStatusActivityCount = async (whereCondition: any) => {
		try {
			// Validate input
			if (!whereCondition) {
				console.error('No conditions provided for status activity');
				return;
			}

			// Perform API call with error handling
			const { data, status } = await apiCall('/troubleshoot/getStatusActivityCount', { ...whereCondition });

			// Check for successful response
			if (status !== 'success' || !data) {
				console.warn('Failed to retrieve status activity', { status, data });
				props.setTotalOverlayRecords(0);
				props.setTotalOverlayPages(0);
				return;
			}
			data.length > 0 && props.setTotalOverlayRecords(0); props.setTotalOverlayPages(0);

			props.setTotalOverlayRecords(data.totalRecords);
			props.setTotalOverlayPages(Math.ceil((data.totalPages)));

		} catch (error) {
			// Comprehensive error handling
			console.error('Error in getStatusActivity:', error);
			props.setTotalOverlayRecords(0);
			props.setTotalOverlayPages(0);
			// Optionally, you could add error notification to user
			// props.showErrorNotification('Failed to fetch status activity');
		}
	};


	const exportStatusActivity = async (whereCondition: any) => {
		try {
			// Validate input
			if (!whereCondition) {
				console.error('No conditions provided for status activity');
				return;
			}
			props.setOverlayExportDetails([]);
			// Perform API call with error handling
			const { data, status } = await apiCall('/troubleshoot/getStatusActivity', { ...whereCondition });

			// Check for successful response
			if (status !== 'success' || !data) {
				props.setOverlayExportDetails([]);
				console.warn('Failed to retrieve status activity', { status, data });
				return;
			}

			// // Update state with retrieved data
			// if (props.activityFunc) {
			//   props.setOverlayExportDetails(data);
			// }

			// Conditional final target data update
			if (props.selectedAct) {
				props.setOverlayExportDetails(data);
				props.setOverlayExportBtnClicked(false);
			}

		} catch (error) {
			// Comprehensive error handling
			props.set_final_Targetdata([]);
			console.error('Error in getStatusActivity:', error);
		}
	};

	const getAutomationSequence = async (whereCondition: any) => {
		try {
			const { data, status } = await apiCall(`/troubleshoot/getAutomationList`, { ...whereCondition });
			if (data && status == 'success') {
				props.setAutomationJsonData(data);
			}
		} catch (error) {
			console.error("Error in getStatusActivityCnt:", error);
			props.setAutomationJsonData([]);
		}
	}

	const getJsonSchemaQueryPkg = async () => {
		const dartid = 1501
		const dataObject = await apiCall('/softDist/getJsonSchema', { dartid });
		const { status, data } = dataObject
		if (status === 'success' && data.length > 0) {
			var uiSchema = JSON.parse(data?.[0]?.uiSchema);
			uiSchema["ui:submitButtonOptions"] = {
				"norender": true,
			};
			var jsondata = JSON.parse(data?.[0]?.jsonSchema);
			console.log("jsondata=", jsondata);
			(data?.[0]?.jsonSchema ?? null) !== null && props.setJsonDataPkg(jsondata);
			// (data?.core_DartJsonSchema?.[0]?.jsonSchema ?? null) !== null && props.setUiData(jsondata);
			// data?.core_DartJsonSchema[0]?.jsonSchema != undefined && props.setJsonData(jsondata);
			data?.[0]?.uiSchema != undefined && props.setUiDataPkg(uiSchema);
		}
	};

	const getJsonSchemaQueryApp = async () => {
		if (!props.status) {
			const dartid = 1502;
			const dataObject = await apiCall('/softDist/getJsonSchema', { dartid });
			const { status, data } = dataObject

			if (status === 'success' && data.length > 0) {
				var uiSchema = JSON.parse(data[0]?.uiSchema);
				uiSchema["ui:submitButtonOptions"] = {
					"norender": true,
				};

				// get the list of files from s3 and set dropdown
				const headers = {
					'x-auth-token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdGF0dXMiOnRydWUsImlhdCI6MTcwOTEwMzk0NCwiZXhwIjoxNzA5MTA3NTQ0fQ.TrZ0b_SQ5kVQOkTItuuzz4HAZe7QpSZtTzmbw9IB0V8',
					'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
				};
				const requestOptions = {
					method: 'GET', // specify the HTTP method (GET, POST, etc.)
					headers: headers,
					// add other options like 'body' if needed
				};          //await fetch('http://localhost:5001/storage/api/getList',requestOptions)

				try {
					const fileData = await apiCall('/softDist/getFiles')
					// console.log("checking the data response from FILEAPI",data)
					var list = await fileData.data.map((val: any) => val.Key)
					console.log("check with LIST", list)
					// getJSONForm();
					// setFilesList(list)
				} catch (error: any) { console.error('Error fetching files:', error) };

				var jsonSchemaData = JSON.parse(data[0]?.jsonSchema);
				if (jsonSchemaData?.items?.allOf[0]?.dependencies?.Application_details?.oneOf[1]?.properties?.uploadApplication1) {
					// jsonSchemaData.items.allOf[0].dependencies.Application_details.oneOf[1].properties.uploadApplication1.enumNames = filesList;//map same thing at
					// jsonSchemaData.items.allOf[0].dependencies.Application_details.oneOf[1].properties.uploadApplication1.enum = filesList//both places.
				}
				console.log("jsonSchemaData=", jsonSchemaData);
				(data?.[0]?.jsonSchema ?? null) !== null && props.setJsonDataApp(jsonSchemaData);
				// data[0]?.jsonSchema != undefined && props.setJsonData(jsonSchemaData);
				data[0]?.uiSchema != undefined && props.setUiDataApp(uiSchema);
			}
		} else {
			const dartid = 1502;
			const dataObject = await apiCall('/softDist/getJsonSchema', { dartid });
			const { status, data } = dataObject
			if (status === 'success' && data.lenght > 0) {
				var uiSchema = JSON.parse(data[0]?.uiSchema);
				uiSchema["ui:submitButtonOptions"] = {
					"norender": true,
				};
				var jsonSchemaData = JSON.parse(data[0]?.jsonSchema);
				console.log("jsonSchemaData=", jsonSchemaData);
				(data?.[0]?.jsonSchema ?? null) !== null && props.setJsonDataApp(jsonSchemaData);
				// data[0]?.jsonSchema != undefined && props.setJsonData(jsonSchemaData);
				data[0]?.uiSchema != undefined && props.setUiDataApp(uiSchema);
			}
		}
	};

	const getJsonSchemaQueryAdv = async () => {
		const dartid = 1503;
		const dataObject = await apiCall('/softDist/getJsonSchema', { dartid });
		const { status, data } = dataObject
		if (status === "success" && data.length > 0) {
			var uiSchema = JSON.parse(data?.[0]?.uiSchema);
			uiSchema["ui:submitButtonOptions"] = {
				"norender": true,
			};
			var jsonSchemaData = JSON.parse(data?.[0]?.jsonSchema);
			console.log("jsonSchemaData=", jsonSchemaData);
			(data?.[0]?.jsonSchema ?? null) !== null && props.setJsonDataAdv(jsonSchemaData);
			// data?.core_DartJsonSchema[0]?.jsonSchema != undefined && props.setJsonData(jsonSchemaData);
			data?.[0]?.uiSchema != undefined && props.setUiDataAdv(uiSchema);
		}
	};

	const app_packageId = props.IDX ? props.IDX : 0;
	const getJSONForm = async (app_packageId: any) => {
		try {
			const data = await apiCall('/softDist/getPackagesFormData', { app_packageId });
			if (data.status === "success") {
				props.handleEditData(data)
			} else {
				props.handleEditData([])
			}
		} catch (error) {
			console.error("An unexpected error occurred:", (error as Error).message);
		}
	};

	var machineName = contextValue?.logedInFrom?.platform === "ServiceNow" ? contextValue?.logedInFrom?.device : "";
	let selectedActname = props.jobType == "Interactive" ? selectedActivity.name : `SWD : ${selectedActivity.name}`;
	let selectedActTime = selectedActivity.time;
	useEffect(() => {

		if (props.searchVal?.length > 0 && props.searchVal !== '') {
			getStatusList({ JobType: props.jobType, function: 'search', search: props.searchVal, site: tenantName }, 50, parseInt(props.pageNo));
			getStatusListCnt({ JobType: props.jobType, function: 'search', search: props.searchVal, site: tenantName });

		} else if (props.isOverlayFilter === true && props.overlayFilterArray.length > 0) {
			const selectedActivityTime = parseInt(selectedActTime);
			getStatusActivity({ automationName: selectedActname, JobCreatedTime: selectedActivityTime, JobType: props.jobType, site: tenantName, function: 'filter', filter: props.overlayFilterArray });
			getStatusActivityCount({ automationName: selectedActname, JobCreatedTime: selectedActivityTime, JobType: props.jobType, site: tenantName, function: 'filter', filter: props.overlayFilterArray });

		} else if (props.deviceSearchVal !== '' && props.deviceSearchVal.length > 0) {
			const selectedActivityTime = parseInt(selectedActTime);
			getStatusActivity({ automationName: selectedActname, JobCreatedTime: selectedActivityTime, JobType: props.jobType, site: tenantName, function: 'search', search: props.deviceSearchVal });
			getStatusActivityCount({ automationName: selectedActname, JobCreatedTime: selectedActivityTime, JobType: props.jobType, site: tenantName, function: 'search', search: props.deviceSearchVal });

		} else if (!props.isRefresh && selectedActivity.name?.length > 0 && selectedActTime) {
			const selectedActivityTime = parseInt(selectedActTime);
			getStatusActivity({ automationName: selectedActname, JobCreatedTime: selectedActivityTime, JobType: props.jobType, site: tenantName, limit: 50, offset: parseInt(props.pageNo) });
			getStatusActivityCount({ automationName: selectedActname, JobCreatedTime: selectedActivityTime, JobType: props.jobType, site: tenantName, limit: 50, offset: parseInt(props.pageNo) });
			// if (props.jobType === 'Software Distribution') {
			// 	getJsonSchemaQueryPkg();
			// 	getJsonSchemaQueryApp();
			// 	getJsonSchemaQueryAdv();
			// 	getJSONForm(app_packageId);
			// }

		} 
		// else if (props.isRefresh) {
		// 	props.setIsRefresh(false);
		// 	props.setRefreshToast(true);
		// 	setTimeout(() => {
		// 		props.setRefreshToast(false);
		// 	}, 5000);
		// }
		 else if (props.isFilter === true && props.filterArray.length > 0) {
			getStatusList({ JobType: props.jobType, MachineTag: machineName, site: tenantName, function: 'filter', filter: props.filterArray }, 50, parseInt(props.pageNo));
			getStatusListCnt({ JobType: props.jobType, MachineTag: machineName, site: tenantName, function: 'filter', filter: props.filterArray });
		} else if (props.automationIds.length > 0) {
			getAutomationSequence({ automationIds: props.automationIds });
		} else {
			getStatusList({ JobType: props.jobType, MachineTag: machineName, site: tenantName }, 50, parseInt(props.pageNo));
			getStatusListCnt({ JobType: props.jobType, MachineTag: machineName, site: tenantName });
		}
	}, [props.searchVal, props.pageNo, props.selectedAct, props.filterArray, props.isFilter, props.deviceSearchVal, props.overlayFilterArray, props.isOverlayFilter]);

	useEffect(() => {
		if (props.exportBtnClicked) {
			exportStatusList({ JobType: props.jobType, MachineTag: machineName, site: tenantName, function: 'export', });
		}
		if (props.isRefresh) { 
			getStatusList({ JobType: props.jobType, MachineTag: machineName, site: tenantName }, 50, parseInt(props.pageNo));
			getStatusListCnt({ JobType: props.jobType, MachineTag: machineName, site: tenantName });
		}
	}, [props.exportBtnClicked, props.isRefresh]);

	useEffect(() => {
		if (props.overlayExportBtnClicked) {
			const selectedActivityTime = parseInt(selectedActTime);
			exportStatusActivity({ automationName: selectedActname, JobCreatedTime: selectedActivityTime, JobType: props.jobType, site: tenantName, function: 'export' });
		}
	}, [props.overlayExportBtnClicked]);

	return (
		<></>
	)
}
